module.exports = __webpack_public_path__ + "img/hook_MARTEC_BKL_2.ab275a24.png";